import { TextArea as BPTextArea } from '@blueprintjs/core';
import * as React from 'react';

import './TextArea.scss';

export interface ITextAreaProps {
  id?: string;
  className?: string;
  label?: React.ReactNode;
  value?: string | ReadonlyArray<string> | number;
  maxLength?: number;
  placeholder?: string;
  autoResize?: boolean;
  onChange?: React.ChangeEventHandler<HTMLTextAreaElement>;
}

const TextArea: React.FC<ITextAreaProps> = ({
  id,
  className = '',
  label,
  value,
  onChange,
  maxLength,
  placeholder,
  autoResize = true,
}) => {
  const fullClassName = `nn-textarea ${className}`;
  return (
    <div className={fullClassName} id={id}>
      {label ? <p>{label}</p> : null}
      <BPTextArea
        className="nn-body-text"
        fill={true}
        autoResize={autoResize}
        value={value}
        onChange={onChange}
        maxLength={maxLength}
        placeholder={placeholder}
      />
    </div>
  );
};

export default TextArea;
